export const REFERRAL_INFO_KEY = 'rushb_referral_info'
export const JWT_KEY = 'rushb_jwt'
export const User_ID_KEY = 'rushb_user_id'
export const IS_NEW_USER = 'rushb_is_new_user'
export const IS_LOGINING = 'rushb_is_logining'
